import axios from "axios";

export const http = axios.create({
    timeout: 30000,
});

export const onSuccess = ({data}) => data;
export const onFail = ({response: {data}}) => {throw data};

export const objectToFormData = (data, formData, path) => {
    if (!formData) {
        formData = new FormData();
    }

    if (data instanceof Array) {
        data.forEach(item => objectToFormData(item, formData, `${path}[]`));
    } else if (data instanceof File) {
        formData.append(path, data);
    } else if (data instanceof Object) {
        Object.keys(data).forEach((key) => objectToFormData(data[key], formData, path ? `${path}[${key}]` : key));
    } else {
        formData.append(path, data);
    }

    return formData;
};
